export const SUPPORTED_AD_TYPES = new Set([
	"HTML_standard",
	"HTML_expand",
	"HTML_onpage",
	"HTML5 onpage",
	"display_html_tag",
	"native_image",
	"altimage",
	"preroll",
	"dynamicPreRoll",
	"dynamic_preroll",
	"JsVPaid",
	"vast_tag",
]);

export const ELIGIBLE_STATUSES = new Set(["UNSUBMITTED", "APPROVED", "FAILED"]);

// The video subset of SUPPORTED_AD_TYPES, lowercased for case-insensitive comparison. Kept local to
// this module (rather than reusing utils/CreativeMap's GENERAL_KENOBI) since that map is missing a
// "dynamicpreroll" entry (only "dynamic_preroll" and a "dynamicprefoll" typo), which would misclassify
// a real dynamicPreRoll video creative as non-video.
const VIDEO_AD_TYPES = new Set(["preroll", "dynamicpreroll", "dynamic_preroll", "jsvpaid", "vast_tag"]);

const VCR_KPI_KEY = "VCR";

export function getScoringEligibleItems(selectedItems) {
	return selectedItems.filter((item) => {
		const { adType, approval } = item || {};
		return SUPPORTED_AD_TYPES.has(adType) && ELIGIBLE_STATUSES.has(approval);
	});
}

export function isEligibleForScoring(adType, approval) {
	return SUPPORTED_AD_TYPES.has(adType) && ELIGIBLE_STATUSES.has(approval);
}

export function isScoringSupportedAdType(adType) {
	return SUPPORTED_AD_TYPES.has(adType);
}

function isVideoAdType(adType) {
	if (!adType) { return false; }
	return VIDEO_AD_TYPES.has(String(adType).toLowerCase());
}

export function isVcrOnlyNonVideoMismatch(adTypes, libraryKpis, availableKpis) {
	if (!libraryKpis?.length || !availableKpis?.length || !adTypes?.length) {
		return false;
	}

	const configuredKpis = libraryKpis
		.map(libraryKpi => availableKpis.find(kpi => kpi.idScoringKpi === libraryKpi.idScoringKpi))
		.filter(Boolean);

	const isVcrOnly = configuredKpis.length === 1 && configuredKpis[0].kpiKey === VCR_KPI_KEY;
	if (!isVcrOnly) {
		return false;
	}

	return adTypes.some(adType => !isVideoAdType(adType));
}
